import MultiSelectConfigOption from "./MultiSelectConfigOption";

export default class MultiSelectConfigOptionGroup {
    public title: string = "";
    public key: string = "";
    public options: MultiSelectConfigOption[] = [];
}